export function createLoadBar(setVisible, showDelayMs, minVisibleMs) {
    let visible = false;
    let showTimer = null;
    let hideTimer = null;
    let shownAt = null;
    const start = () => {
        if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
        }
        if (visible || showTimer)
            return;
        showTimer = setTimeout(() => {
            showTimer = null;
            shownAt = Date.now();
            visible = true;
            setVisible(true);
        }, showDelayMs);
    };
    const stop = () => {
        if (showTimer) {
            clearTimeout(showTimer);
            showTimer = null;
        }
        if (!visible)
            return;
        const elapsed = shownAt ? Date.now() - shownAt : minVisibleMs;
        const remaining = Math.max(0, minVisibleMs - elapsed);
        if (remaining === 0) {
            visible = false;
            shownAt = null;
            setVisible(false);
            return;
        }
        hideTimer = setTimeout(() => {
            hideTimer = null;
            visible = false;
            shownAt = null;
            setVisible(false);
        }, remaining);
    };
    const dispose = () => {
        if (showTimer)
            clearTimeout(showTimer);
        if (hideTimer)
            clearTimeout(hideTimer);
        showTimer = null;
        hideTimer = null;
    };
    return { start, stop, dispose, isVisible: () => visible };
}
